<template>
  <div class="p1_sbar">
    <!---s-bt-主页-选中-->
    <div class="p1_buttonzhuyxz">
      <img class="p1_dizhuyxz" src="@/assets/p1/images/imgzhuy-xz.png"
           referrerpolicy="no-referrer" v-if="value == 1" />
      <img class="p1_dizhuyxz" src="@/assets/p2/images/imgzhuy-wxz.png" @click="gotoUrl('/')" referrerpolicy="no-referrer" v-else />
    </div>
    <!---s-bt-唤醒回忆-未选中-->
    <div class="p1_buttonhuanxhywxz">
      <img class="p1_dizhuyxz" src="../../assets/p2/images/imghuanxhy-xz.png" referrerpolicy="no-referrer"
           v-if="value == 2"/>
      <img class="p1_dizhuyxz" @click="gotoUrl('/memory')" src="@/assets/p1/images/imghuanxhy-wxz.png"
           referrerpolicy="no-referrer" v-else />
    </div>
    <!---s-bt-回忆图鉴-未选中-->
    <div class="p1_buttonhuiytjwxz">
      <img class="p1_dizhuyxz"
           src="@/assets/p3/images/imghuiytj-xz.png"
           referrerpolicy="no-referrer" v-if="value == 3" />
      <img class="p1_dizhuyxz" @click="gotoUrl('/illustration')"
                                         src="@/assets/p1/images/imghuiytj-wxz.png"
                                         referrerpolicy="no-referrer" v-else />
    </div>
    <!---s-bt-兑换奖励-未选中-->
    <div class="p1_buttonduihjlwxz">
      <img class="p1_dizhuyxz"
           src="@/assets/p4/images/imgduihjl-xz.png"
           referrerpolicy="no-referrer" v-if="value == 4" />
      <img class="p1_dizhuyxz" @click="gotoUrl('/reward')"
           src="@/assets/p1/images/imgduihjl-wxz.png"
           referrerpolicy="no-referrer" v-else />
    </div>
    <!---s-bt-活动规则-未选中-->
    <div class="p1_buttonhuodgzwxz">
      <img class="p1_dizhuyxz" v-if="value == 5"
           src="@/assets/p5/images/imghuodgz-xz.png"
           referrerpolicy="no-referrer"/>
      <img class="p1_dizhuyxz" @click="gotoUrl('/rule')"
           src="@/assets/p1/images/imghuodgz-wxz.png" v-else
           referrerpolicy="no-referrer"/>
    </div>
  </div>
</template>

<style scoped>
@import "../../assets/p1/css/s1.css";
</style>
<script>

export default {
  name: 'Bar',
  props: ["value"],
  data() {
    return {};
  },

  methods: {
    gotoUrl(url) {
      this.$router.push(url);
    }
  },
  mounted() {

  },
};
</script>
<style scoped>

.p1_sbar {
  top: max(11.66rem, calc(100vh - 0.34rem - 1.35rem));
}
</style>